import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  missingParameter: {
    id: '2yZfcu',
    description: 'Error when the version query parameter is missing from the install page URL',
    defaultMessage: 'Missing required parameter. URL must include ?version=...',
  },
  loadingVersionDetails: {
    id: '5xa1DK',
    description: 'Loading message while app version details are being fetched',
    defaultMessage: 'Loading app version details...',
  },
  failedToLoad: {
    id: 'MbmVQJ',
    description: 'Error message when app version details fail to load',
    defaultMessage: 'Failed to load app version details.',
  },
  versionNotPublished: {
    id: 'jdmdnP',
    description: 'Error when the app version is not in published status',
    defaultMessage: 'Version is not published (status: {status}).',
  },
  installedTitle: {
    id: 'oDLNp/',
    description: 'Success heading after app is installed',
    defaultMessage: '{appName} installed',
  },
  installedDescription: {
    id: 'NqJnBe',
    description: 'Success message after app version is installed',
    defaultMessage: 'Version {version} has been installed successfully.',
  },
  permissionsHeading: {
    id: '/oh/za',
    description: 'Heading for the permissions/scopes section on install page',
    defaultMessage: 'This app requests the following permissions:',
  },
  noPermissionsRequired: {
    id: 'bTAsZT',
    description: 'Message when the app version requires no special permissions',
    defaultMessage: 'This app does not require any special permissions.',
  },
  failedToInstall: {
    id: '/BrzVP',
    description: 'Error message when the install API call fails',
    defaultMessage: 'Failed to install app.',
  },
  installButton: {
    id: '8kWi7k',
    description: 'Button label to install the app version',
    defaultMessage: 'Install App',
  },
  versionLabel: {
    id: 'y/XX3v',
    description: 'Label showing the version number of the app',
    defaultMessage: 'Version {version}',
  },
});
